export default __webpack_public_path__ + "static/gina-a95cc9bdc23302aaed8aa04a63135b70.png";